// Calendar-related root state — merged into the workspace shell via sharedLibraries.

export default {
  viewMode: 'week',
  selectedEvent: null,
  calendarEvents: [],
  calendarLoading: false,
  // Team roster customisation is intentionally session-local. These keys
  // never participate in calendar fetch/save payloads.
  teamMembers: [],
  showAddTeammates: false,
  addTeammateQuery: '',
  addTeammateFeedback: '',
  // Phone rail (CalRailSheet) open flag. Declared here — and NOT only where
  // it's written — because this slice is seeded at boot via the calendar eager
  // slice, and v3.14 root.update() on an undeclared key trips the schema
  // check. The sheet, the header's CalRailBtn chip and the left-edge pull all
  // write it.
  _calRailOpen: false
}
